import * as Yup from "yup";

export const packageSchema = Yup.object().shape({
  name: Yup.string()
    .required("Nome é obrigatório")
    .min(2, "Nome deve ter pelo menos 2 caracteres"),

  validity_months: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" ? null : Number(originalValue),
    )
    .typeError("Validade (meses) deve ser um número")
    .required("Validade (meses) é obrigatória")
    .min(1, "Validade mínima é de 1 mês")
    .max(120, "Validade máxima é de 120 meses"),

  sale_commission_percentage: Yup.string()
    .transform((value) => {
      if (typeof value === "string") {
        return value.replace(/[^\d.,]/g, "").replace(",", ".");
      }
      return value;
    })
    .test(
      "is-valid",
      "Comissão deve ser um número válido maior ou igual a zero",
      (value) => {
        if (!value) return false;
        const num = parseFloat(value);
        return !isNaN(num) && num >= 0;
      },
    ),

  services: Yup.array().of(
    Yup.object().shape({
      service_id: Yup.string().required("Serviço é obrigatório"),
      usage_limit: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? null : Number(originalValue),
        )
        .typeError("Limite de uso deve ser um número")
        .required("Limite de uso é obrigatório")
        .min(1, "Limite de uso deve ser pelo menos 1"),

      reference_price: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? null : Number(originalValue),
        )
        .typeError("Preço de referência deve ser um número")
        .required("Preço de referência é obrigatório")
        .min(0.01, "Preço de referência deve ser maior que zero"),
    }),
  ),
});
